/**
 * @module actionEndpointStore
 */

import { createStore } from 'satcheljs';
import { DEFAULT_ACTION_ENDPOINT_URL } from '../constants';
import ActionEndpoint, {
    ActionEndpointCache,
    ActionEndpointCacheState,
    ActionEndpointRequestState,
} from './schema/actionEndpointCache';

/**
 * Initial value for the action endpoint cache
 */
const initialActionEndpointCache: ActionEndpointCache = {
    data: {
        Url: DEFAULT_ACTION_ENDPOINT_URL,
    },
    state: ActionEndpointCacheState.Empty,
    time: null,
};

/**
 * Initial data for action endpoint store.
 */
const initialActionEndpoint: ActionEndpoint = {
    cache: initialActionEndpointCache,
    requestState: ActionEndpointRequestState.UnResolved,
};

/**
 * Store for Action Endpoint.
 */
const actionEndpointStore = createStore<ActionEndpoint>(
    'amActionEndpointStore',
    initialActionEndpoint
)();

export default actionEndpointStore;
